<div class="open-messages-page">
  <div class="header">
    <h1>{{ 'openMessages.title' | translate }}</h1>
    <div class="header-content">
      <div class="actions">
        <ecab-button class="btn-back" variant="text" icon="arrow_back" [label]="'common.actions.back' | translate" (clicked)="location.back()"></ecab-button>
        <ecab-button class="btn-refresh" variant="primary" icon="refresh" [label]="'openMessages.actions.refresh' | translate" (clicked)="loadOpenMessages()"></ecab-button>
      </div>
    </div>
  </div>

  <section class="filter-workspace" data-testid="filter-workspace">
    <div class="filter-top-row">
      <ecab-input
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange()"
        [placeholder]="'common.search' | translate"
        icon="search"
        iconPosition="prefix"
        class="search-input">
      </ecab-input>
    </div>
    <mat-expansion-panel
      class="workspace-panel filter-panel"
      [expanded]="advancedFiltersSectionExpanded"
      (opened)="setSectionExpanded('advanced', true)"
      (closed)="setSectionExpanded('advanced', false)">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span class="material-icons">tune</span>
          {{ 'filter.workspace.advanced' | translate }}
        </mat-panel-title>
        @if (!advancedFiltersSectionExpanded) {
          <mat-panel-description>{{ advancedFiltersSectionSummary }}</mat-panel-description>
        }
      </mat-expansion-panel-header>
      <div class="filter-content workspace-panel-content">
        <div class="filter-row">
          <ecab-select class="filter-field"
                      [(ngModel)]="buildingMode"
                      [label]="'filter.buildingMode' | translate"
                      [options]="[
                        {value: FilterMode.ALL, label: 'filter.mode.all' | translate},
                        {value: FilterMode.EMPTY, label: 'filter.mode.empty' | translate},
                        {value: FilterMode.SELECTED_VALUES, label: 'filter.mode.selectedValues' | translate}
                      ]"
                      (selectionChange)="onBuildingModeChange()">
          </ecab-select>
          <ecab-input class="filter-field"
                      [(ngModel)]="buildingIdFilter"
                      [label]="'filter.buildingId' | translate"
                      [placeholder]="'filter.multiValueHint' | translate"
                      [disabled]="buildingMode !== FilterMode.SELECTED_VALUES">
          </ecab-input>
          <ecab-input class="filter-field"
                      [(ngModel)]="caseIdFilter"
                      [label]="'filter.caseId' | translate"
                      [placeholder]="'filter.caseId' | translate">
          </ecab-input>
          <ecab-select class="filter-field"
                      [(ngModel)]="townGroupIds"
                      [multiple]="true"
                      [label]="'filter.townGroup' | translate"
                      [placeholder]="'filter.townGroup' | translate"
                      [options]="townGroupOptions">
          </ecab-select>
          <ecab-select class="filter-field"
                      [(ngModel)]="personMode"
                      [label]="'filter.personMode' | translate"
                      [options]="[
                        {value: FilterMode.ALL, label: 'filter.mode.all' | translate},
                        {value: FilterMode.EMPTY, label: 'filter.mode.empty' | translate},
                        {value: FilterMode.SELECTED_VALUES, label: 'filter.mode.selectedValues' | translate}
                      ]"
                      (selectionChange)="onPersonModeChange()">
          </ecab-select>
          <ecab-input class="filter-field"
                      [(ngModel)]="personIdFilter"
                      [label]="'filter.personId' | translate"
                      [placeholder]="'filter.multiValueHint' | translate"
                      [disabled]="personMode !== FilterMode.SELECTED_VALUES">
          </ecab-input>
          <ecab-select class="filter-field"
                      [(ngModel)]="caseTypeFilter"
                      [label]="'filter.category' | translate"
                      [placeholder]="'filter.category' | translate"
                      [options]="[
                        {value: undefined, label: 'caseType.all' | translate},
                        {value: CaseType.NONE, label: 'caseType.none' | translate},
                        {value: CaseType.DAMAGE, label: 'caseType.damage' | translate},
                        {value: CaseType.ESTIMATION, label: 'caseType.estimation' | translate},
                        {value: CaseType.SUBSIDY, label: 'caseType.subsidy' | translate}
                      ]">
          </ecab-select>
          <ecab-select class="filter-field"
                      [(ngModel)]="questionTypeFilter"
                      [label]="'filter.questionType' | translate"
                      [options]="getQuestionTypeOptions()">
            @if (questionTypeFilter) {
              <button matSuffix mat-icon-button type="button" [attr.aria-label]="'common.actions.clear' | translate" (click)="questionTypeFilter=undefined; $event.stopPropagation()">
                <mat-icon>close</mat-icon>
              </button>
            }
          </ecab-select>
        </div>
        <div class="filter-actions">
          <ecab-button variant="primary" icon="check" [label]="'filter.apply' | translate" (clicked)="applyFilters()"></ecab-button>
          <ecab-button variant="secondary" icon="clear" [label]="'filter.clear' | translate" (clicked)="clearFilters()"></ecab-button>
        </div>
      </div>
    </mat-expansion-panel>
  </section>

  @if (loading) {
    <div class="loading-state">
      <span class="material-icons spinning">sync</span>
      <p>{{ 'openMessages.loading' | translate }}</p>
    </div>
  } @else {
    <!-- Assigned to Me -->
    <section class="message-section">
      <div class="section-header assigned-to-me">
        <span class="material-icons">person</span>
        <h2>{{ 'openMessages.sections.assignedToMe' | translate }}</h2>
        <span class="count-badge">{{ assignedToMe.length }}</span>
      </div>

      <div class="messages-list">
        @for (msg of assignedToMe; track msg.id) {
          <div class="message-card" (click)="openMessage(msg)">
            <div class="message-avatar" [style.background-color]="getAvatarColor(msg)">
              {{ getInitials(msg) }}
            </div>
            <div class="message-info">
              <div class="message-top">
                <span class="contact-name">{{ getContactDisplay(msg) }}</span>
                <span class="message-date">{{ msg.date | date:'dd.MM.yyyy HH:mm' }}</span>
              </div>
              <div class="message-middle">
                <span class="message-subject">{{ msg.subject }}</span>
                <span class="channel-badge">{{ msg.channel }}</span>
              </div>
              <div class="message-bottom">
                <p class="message-preview">{{ msg.content | markdownExcerpt:160 }}</p>
                <div class="collaborator-row">
                  <span class="collaborator-label">
                    <span class="material-icons">assignment_ind</span>
                    {{ getCollaboratorDisplay(msg) || ('message.context.noCollaborator' | translate) }}
                  </span>
                  <ecab-button class="btn-reassign" variant="text" icon="swap_horiz" [label]="'openMessages.actions.reassign' | translate" (clicked)="msg.id && switchEditCollaborator(msg.id, $event)"></ecab-button>
                </div>
                @if (editingCollaboratorId() === msg.id) {
                  <div class="collaborator-select" (click)="$event.stopPropagation()">
                    <ecab-select [placeholder]="'openMessages.selectCollaborator' | translate"
                      (selectionChange)="onCollaboratorChange(msg, $event, $event)"
                      [options]="getCollaboratorOptions(true)">
                    </ecab-select>
                  </div>
                }
              </div>
            </div>
          </div>
        } @empty {
          <div class="no-messages">
            <span class="material-icons">check_circle</span>
            <p>{{ 'openMessages.empty.assignedToMe' | translate }}</p>
          </div>
        }
      </div>
    </section>

    <!-- Unassigned -->
    <section class="message-section">
      <div class="section-header unassigned">
        <span class="material-icons">person_off</span>
        <h2>{{ 'openMessages.sections.unassigned' | translate }}</h2>
        <span class="count-badge">{{ unassigned.length }}</span>
      </div>

      <div class="messages-list">
        @for (msg of unassigned; track msg.id) {
          <div class="message-card" (click)="openMessage(msg)">
            <div class="message-avatar" [style.background-color]="getAvatarColor(msg)">
              {{ getInitials(msg) }}
            </div>
            <div class="message-info">
              <div class="message-top">
                <span class="contact-name">{{ getContactDisplay(msg) }}</span>
                <span class="message-date">{{ msg.date | date:'dd.MM.yyyy HH:mm' }}</span>
              </div>
              <div class="message-middle">
                <span class="message-subject">{{ msg.subject }}</span>
                <span class="channel-badge">{{ msg.channel }}</span>
              </div>
              <div class="message-bottom">
                <p class="message-preview">{{ msg.content | markdownExcerpt:160 }}</p>
                <div class="collaborator-row">
                  <span class="collaborator-label unassigned-label">
                    <span class="material-icons">person_off</span>
                    {{ 'message.context.noCollaborator' | translate }}
                  </span>
                  <ecab-button class="btn-reassign" variant="text" icon="person_add" [label]="'openMessages.actions.assign' | translate" (clicked)="msg.id && switchEditCollaborator(msg.id, $event)"></ecab-button>
                </div>
                @if (editingCollaboratorId() === msg.id) {
                  <div class="collaborator-select" (click)="$event.stopPropagation()">
                    <ecab-select [placeholder]="'openMessages.selectCollaborator' | translate"
                      (selectionChange)="onCollaboratorChange(msg, $event, $event)"
                      [options]="getCollaboratorOptions(false)">
                    </ecab-select>
                  </div>
                }
              </div>
            </div>
          </div>
        } @empty {
          <div class="no-messages">
            <span class="material-icons">inbox</span>
            <p>{{ 'openMessages.empty.unassigned' | translate }}</p>
          </div>
        }
      </div>
    </section>

    <!-- Assigned to Others -->
    <section class="message-section">
      <div class="section-header assigned-to-others">
        <span class="material-icons">group</span>
        <h2>{{ 'openMessages.sections.assignedToOthers' | translate }}</h2>
        <span class="count-badge">{{ assignedToOthers.length }}</span>
      </div>

      <div class="messages-list">
        @for (msg of assignedToOthers; track msg.id) {
          <div class="message-card" (click)="openMessage(msg)">
            <div class="message-avatar" [style.background-color]="getAvatarColor(msg)">
              {{ getInitials(msg) }}
            </div>
            <div class="message-info">
              <div class="message-top">
                <span class="contact-name">{{ getContactDisplay(msg) }}</span>
                <span class="message-date">{{ msg.date | date:'dd.MM.yyyy HH:mm' }}</span>
              </div>
              <div class="message-middle">
                <span class="message-subject">{{ msg.subject }}</span>
                <span class="channel-badge">{{ msg.channel }}</span>
              </div>
              <div class="message-bottom">
                <p class="message-preview">{{ msg.content | markdownExcerpt:160 }}</p>
                <div class="collaborator-row">
                  <span class="collaborator-label">
                    <span class="material-icons">assignment_ind</span>
                    {{ getCollaboratorDisplay(msg) }}
                  </span>
                  <ecab-button class="btn-reassign" variant="text" icon="swap_horiz" [label]="'openMessages.actions.reassign' | translate" (clicked)="msg.id && switchEditCollaborator(msg.id, $event)"></ecab-button>
                </div>
                @if (editingCollaboratorId() === msg.id) {
                  <div class="collaborator-select" (click)="$event.stopPropagation()">
                    <ecab-select [placeholder]="'openMessages.selectCollaborator' | translate"
                      (selectionChange)="onCollaboratorChange(msg, $event, $event)"
                      [options]="getCollaboratorOptions(true)">
                    </ecab-select>
                  </div>
                }
              </div>
            </div>
          </div>
        } @empty {
          <div class="no-messages">
            <span class="material-icons">groups</span>
            <p>{{ 'openMessages.empty.assignedToOthers' | translate }}</p>
          </div>
        }
      </div>
    </section>
  }
</div>
